export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة المرور القديمة"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة المرور الجديدة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد كلمة المرور"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"كلمة المرور الجديدة\" و \"تأكيد كلمة المرور\" غير متطابقتين."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تغيير كلمة المرور"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سلسلة من 4 إلى 63 حرفًا. الأحرف المسموح بها هي الأحرف اللاتينية، الأرقام والرموز"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فارغ"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ضعيف"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متوسط"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قوي"])}
  }
}